import { fade } from '@material-ui/core/styles/colorManipulator'
import { Overrides } from '@material-ui/core/styles/overrides'

import { textPalette, masmovilPalette, llamayaPalette } from './colors'
import { fonts } from './fonts'

import { deepMerge } from '../../utils'

const commonTabOverride: Overrides = {
  MuiTabs: {
    root: {
      minHeight: '40px',
    },
    indicator: {
      backgroundColor: 'transparent',
    },
  },
  MuiTab: {
    root: {
      '&': {
        minWidth: 'unset',
      },
      padding: '8px 18px',
      minHeight: '40px',
      fontSize: fonts.size.small,
      fontWeight: 'bold',
      '&.Mui-selected': {
        borderRadius: '8px',
      },
    },
    textColorInherit: {
      '&.Mui-selected': {
        color: textPalette.primary,
      },
    },
    wrapper: {
      textTransform: 'none',
    },
  },
}

export const masmovilTabOverride: Overrides = deepMerge(commonTabOverride, {
  MuiTab: {
    root: {
      '&.Mui-selected': {
        backgroundColor: masmovilPalette.primary.light,
      },
    },
  },
})

export const llamayaTabOverride: Overrides = deepMerge(commonTabOverride, {
  MuiTab: {
    root: {
      '&.Mui-selected': {
        backgroundColor: fade(llamayaPalette.secondary.light, 0.25),
      },
    },
  },
})
